new MutationObserver(() => {
    fixAccessibility();
    fixAriaHidden();
}).observe(document.body, { childList: true, subtree: true });

const fixAccessibility = () => {
    document.querySelectorAll('img').forEach(el => {
        if (!el.hasAttribute('alt')) {
            el.setAttribute('alt', '')
        }
    })
}

fixAccessibility();

const fixAriaHidden = () => {
    document.querySelectorAll('[aria-hidden="true"]').forEach(hiddenElement => {
        hiddenElement.querySelectorAll('a, button, input, select, textarea, [tabindex]').forEach(focusable => {
            focusable.setAttribute('tabindex', '-1');
        });
    });

    document.querySelectorAll('[aria-hidden="false"]').forEach(visibleElement => {
        visibleElement.querySelectorAll('[tabindex="-1"]').forEach(focusable => {
            focusable.removeAttribute('tabindex');
        });
    });
};

fixAriaHidden();

new MutationObserver(fixAriaHidden).observe(document.body, { attributes: true, subtree: true, attributeFilter: ['aria-hidden'] });
